const MODAL_CHANGE_INDEX = 'IMAGE_SLIDER_CHANGE_INDEX';
const MODAL_CLOSE = 'IMAGE_SLIDER_CLOSE_MODAL';

export default function ImageSlider() {
  return {
    index: 0,
    count: 0,
    isOpen: false,

    get isFirst() {
      return this.index <= 0;
    },

    get isLast() {
      return this.index >= this.count - 1;
    },

    get activeTrack() {
      return this.isOpen ? this.$refs.modalTrack : this.$refs.track;
    },

    get activeThumbnails() {
      return this.isOpen ? this.$refs.modalThumbnails : this.$refs.thumbnails;
    },

    get isVideo() {
      const modalTrack = this.$refs.modalTrack;

      if (!modalTrack) {
        return false;
      }

      const slide = modalTrack.children[this.index];

      return Boolean(slide && slide.hasAttribute('data-video'));
    },

    reset(index) {
      this.count = this.$refs.track.children.length;
      this.goTo(index, 'instant');
    },

    onScroll(track) {
      if (track !== this.activeTrack || !track.clientWidth) {
        return;
      }

      this.setIndex(Math.round(track.scrollLeft / track.clientWidth));
      this.centerThumbnail();
    },

    open() {
      this.isOpen = true;
      document.documentElement.classList.add('no-scroll');
      this.scrollToIndex(this.$refs.modalTrack, 'instant');
      this.centerThumbnail('instant');
    },

    close() {
      if (!this.isOpen) {
        return;
      }

      this.isOpen = false;
      document.documentElement.classList.remove('no-scroll');
      Livewire.dispatch(MODAL_CLOSE);
      this.scrollToIndex(this.$refs.track, 'instant');
      this.centerThumbnail('instant');
    },

    previous() {
      this.goTo(this.index - 1);
    },

    next() {
      this.goTo(this.index + 1);
    },

    goTo(index, behavior = 'smooth') {
      this.setIndex(Math.min(Math.max(index, 0), Math.max(this.count - 1, 0)));
      this.scrollToIndex(this.activeTrack, behavior);
      this.centerThumbnail(behavior);
    },

    setIndex(index) {
      if (index === this.index) {
        return;
      }

      this.index = index;

      if (this.isOpen) {
        Livewire.dispatch(MODAL_CHANGE_INDEX);
        this.scrollToIndex(this.$refs.track, 'smooth');
        this.centerThumbnail('smooth', this.$refs.thumbnails);
      }
    },

    scrollToIndex(track, behavior) {
      track.scrollTo({ left: this.index * track.clientWidth, behavior });
    },

    centerThumbnail(behavior = 'smooth', thumbnails = this.activeThumbnails) {
      if (!thumbnails) {
        return;
      }

      const thumbnail = thumbnails.children[this.index];

      if (!thumbnail) {
        return;
      }

      thumbnails.scrollTo({
        left: thumbnail.offsetLeft + (thumbnail.offsetWidth / 2) - (thumbnails.clientWidth / 2),
        behavior
      });
    }
  };
}
